import { FC } from "react";
import {
  LineChart as RechartLineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Chart } from "../types";
import { ValueType } from "recharts/types/component/DefaultTooltipContent";

interface LineData {
  dataKey: string;
  name: string;
  color: string;
  dashed?: boolean;
}

interface LineChartProps {
  data: Chart["chartData"];
  xAxisKey: string;
  lines: LineData[];
}

export const LineChart: FC<LineChartProps> = (props) => {
  const valueFormatter = (value: ValueType) => {
    const nValue: number = parseInt(value.toString());

    if (nValue >= 1_000_000) return `$${(nValue / 1_000_000).toFixed(1)}M`;
    if (nValue >= 1_000) return `$${(nValue / 1_000).toFixed(0)}K`;

    return `$${nValue}`;
  };

  return (
    <ResponsiveContainer width="100%" height={400}>
      <RechartLineChart
        data={props.data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={props.xAxisKey} />
        <YAxis tickFormatter={valueFormatter} />
        <Tooltip formatter={(value) => valueFormatter(value)} />
        <Legend />
        {props.lines.map((line, index) => {
          return (
            <Line
              key={index}
              type="monotone"
              dataKey={line.dataKey}
              name={line.name}
              stroke={line.color}
              strokeWidth={3}
              strokeDasharray={line.dashed ? "5 5" : 0}
              activeDot={{ r: 6 }}
            />
          );
        })}
      </RechartLineChart>
    </ResponsiveContainer>
  );
};
